import { render } from "./Product.vue?vue&type=template&id=261f4e75&scoped=true"
import script from "./Product.vue?vue&type=script&lang=js"
export * from "./Product.vue?vue&type=script&lang=js"

import "./Product.vue?vue&type=style&index=0&id=261f4e75&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-261f4e75"

export default script